import { create } from "zustand";

const AllotmentStore = create((set) => ({
  allotmentId: "",

  setlAllotmentId: (_id) => {
    set((prev) => ({ ...prev, id: _id }));
  },
}));
export default AllotmentStore;
